import React from 'react';
import { Section } from 'src/components/widgets/section';
import { SkeletonBlock } from 'src/components/widgets/skeleton';
import Stack from 'src/components/widgets/stack/stack';
import { Columns } from 'src/components/widgets/columns';
import { T } from 'src/shared/helpers';

const EarningsSkeleton = () => (
    <Section>
        <Stack $gap='20px' aria-busy='true' aria-label={T._('Loading', 'Admin')}>
            <Columns $xs={2}>
                <SkeletonBlock $width='150px' $height='58px' />
                <SkeletonBlock $width='150px' $height='58px' />
            </Columns>
            <SkeletonBlock $width='100%' $height='32px' />
            <SkeletonBlock $width='100%' $height='350px' />
        </Stack>
    </Section>
);

export default EarningsSkeleton;
